import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import {
  resetAllApiStatus,
  fetchTagsApiThunk,
  createTagApiThunk,
  updateTagApiThunk,
  getTagApiThunk,
  deleteTagApiThunk,
} from './tagsSlice';
import { RootState } from '..';
import {
  ListTagsRequest,
  CreateTagRequest,
  UpdateTagRequest,
  GetTagRequest,
  DeleteTagRequest,
} from 'src/types/helios/Tags';

export const useTags = () => {
  const dispatch = useAppDispatch();

  // Selectors
  const tagsList = useAppSelector((state: RootState) => state.tags.tags);
  const selectedTag = useAppSelector((state: RootState) => state.tags.selectedTag);
  const fetchTagsApiStatus = useAppSelector(
    (state: RootState) => state.tags.fetchTagsApiStatus,
  );
  const getTagApiStatus = useAppSelector(
    (state: RootState) => state.tags.getTagApiStatus,
  );
  const createTagApiStatus = useAppSelector(
    (state: RootState) => state.tags.createTagApiStatus,
  );
  const updateTagApiStatus = useAppSelector(
    (state: RootState) => state.tags.updateTagApiStatus,
  );
  const deleteTagApiStatus = useAppSelector(
    (state: RootState) => state.tags.deleteTagApiStatus,
  );
  const nextToken = useAppSelector((state: RootState) => state.tags.nextToken);

  // Load tags
  const loadTags = useCallback(
    (params: ListTagsRequest) => {
      dispatch(fetchTagsApiThunk({ isActive: true, ...params }));
    },
    [dispatch],
  );

  // Create tag
  const createTag = useCallback(
    (data: CreateTagRequest) => {
      return dispatch(createTagApiThunk(data));
    },
    [dispatch],
  );

  // Update tag
  const updateTag = useCallback(
    (data: UpdateTagRequest) => {
      return dispatch(updateTagApiThunk(data));
    },
    [dispatch],
  );

  // Get tag
  const getTag = useCallback(
    (data: GetTagRequest) => {
      return dispatch(getTagApiThunk(data));
    },
    [dispatch],
  );

  // Delete tag
  const deleteTag = useCallback(
    (data: DeleteTagRequest) => {
      return dispatch(deleteTagApiThunk(data));
    },
    [dispatch],
  );

  // Clear API status messages
  const clearAPIStatusMessage = useCallback(() => {
    dispatch(resetAllApiStatus());
  }, [dispatch]);

  return {
    // State
    tagsList,
    selectedTag,
    nextToken,
    fetchTagsApiStatus,
    getTagApiStatus,
    createTagApiStatus,
    updateTagApiStatus,
    deleteTagApiStatus,
    // Actions
    loadTags,
    createTag,
    updateTag,
    getTag,
    deleteTag,
    clearAPIStatusMessage,
  };
};
